var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import LeftTree from "./LeftTree.vue";
import RecordHeader from "./RecordHeader.vue";
import RecordTable from "./RecordTable.vue";
import UpperSupCheckService from '../../../api/UpperSupCheckService';
import GLOBAL_VUE from '../../../globalVue';
import { Loading } from 'element-ui';
var AccountRecord = (function (_super) {
    __extends(AccountRecord, _super);
    function AccountRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.detail = null;
        _this.total = 0;
        _this.filter = {};
        return _this;
    }
    AccountRecord.prototype.nodeClick = function (data) {
        this.$refs.pagination.clear();
        this.getList(data);
    };
    AccountRecord.prototype.getList = function (detail) {
        var _this = this;
        if (detail === void 0) { detail = {}; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getRecordList(Object.assign({
            supplier_upper_id: detail.supplier_upper_id || this.detail.supplier_upper_id
        }, this.$refs.pagination.pager, detail.supplier_upper_id ? {} : this.filter)).then(function (res) {
            loadingInstance.close();
            _this.detail = Object.assign({}, _this.detail || {}, __assign({}, detail), res.data.data);
            _this.total = res.data.data.total;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    AccountRecord.prototype.headerChange = function (filter) {
        if (!filter.account_date_start || !filter.account_date_end)
            return;
        if (filter.account_date_start) {
            filter.account_date_start = filter.account_date_start.format('yyyy-MM-dd');
        }
        if (filter.account_date_end) {
            filter.account_date_end = filter.account_date_end.format('yyyy-MM-dd');
        }
        this.filter = filter;
        this.$refs.pagination.clear();
        this.getList();
    };
    AccountRecord.prototype.pageChange = function (pager) {
        this.getList();
    };
    AccountRecord.prototype.addTab = function (options) {
        options.opener = this;
        GLOBAL_VUE.$emit('addTab', options);
    };
    AccountRecord.prototype.created = function () {
        this.service = UpperSupCheckService.getInstance();
    };
    AccountRecord = __decorate([
        Component({
            components: {
                "left-tree": LeftTree,
                "record-header": RecordHeader,
                "record-table": RecordTable
            }
        })
    ], AccountRecord);
    return AccountRecord;
}(Vue));
export default AccountRecord;
